import React from 'react';
import { useForm } from '@inertiajs/react';

interface Props {
  flash?: {
    alert?: string;
  };
  email_address?: string;
}

export default function PasswordsNew({ flash, email_address }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: email_address || '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post('/passwords');
  };

  return (
    <div className="auth-container">
      <h1>Forgot your password?</h1>

      {flash?.alert && (
        <div style={{ color: 'red' }}>{flash.alert}</div>
      )}

      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="email"
            value={data.email_address}
            onChange={(e) => setData('email_address', e.target.value)}
            required
            autoFocus
            autoComplete="username"
            placeholder="Enter your email address"
          />
          {errors.email_address && (
            <div style={{ color: 'red' }}>{errors.email_address}</div>
          )}
        </div>

        <button type="submit" disabled={processing}>
          {processing ? 'Sending...' : 'Email reset instructions'}
        </button>
      </form>
    </div>
  );
}